import { useEffect, useState } from "react";
import api from "../../utils/api";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Divider,
} from "@mui/material";

export default function AdminAgentStudentModal({
  agentId,
  student,
  onClose,
}) {
  const [data, setData] = useState({ payments: [], commissions: [] });

  useEffect(() => {
    api
      .get(`/admin/agents/${agentId}/students/${student.student_id}`)
      .then((res) => setData(res.data));
  }, [agentId, student.student_id]);

  return (
    <Dialog open fullWidth maxWidth="md" onClose={onClose}>
      <DialogTitle>{student.student_name}</DialogTitle>

      <DialogContent>
        <Typography variant="subtitle1">Payments</Typography>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Date</TableCell>
              <TableCell>Amount</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.payments.map((p) => (
              <TableRow key={p.id}>
                <TableCell>{p.paid_at}</TableCell>
                <TableCell>₦{p.amount_naira}</TableCell>
                <TableCell>{p.status}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        <Divider sx={{ my: 2 }} />

        <Typography variant="subtitle1">Agent Commissions</Typography>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Type</TableCell>
              <TableCell>Rate</TableCell>
              <TableCell>Amount</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.commissions.map((c, i) => (
              <TableRow key={i}>
                <TableCell>{c.commission_type}</TableCell>
                <TableCell>{c.commission_rate}%</TableCell>
                <TableCell>₦{c.commission_amount}</TableCell>
                <TableCell>{c.status}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogContent>
    </Dialog>
  );
}
